import React, { FC, useEffect } from 'react';
import '../../../../style/style.scss';
import FUNCTIONS from '../../../../helpers/functions';
import { useDispatch, useSelector } from 'react-redux';
import { dataUser, questionsAnswers, questionsRequest, setFinished } from '../../../../redux/questionnaire';
import QuestionPrice from '../../components/question/question_price';
import { login_status } from '../../../../redux/auth';
import CalculateCost from '../../components/calculate_cost/calculate_cost';

const FunctionsManager = FUNCTIONS.instance;

interface Props {
    disabledNextStep: any;
    denniedText: any;
}

interface questionsAnsweredInterface {
    idQuestion: number;
    idAnswer: number | null;
    amount: number | undefined;
}

const PriceQuestions: FC<Props> = (props) => {
  const dispatch = useDispatch<any>();
  const QUESTIONS_REQUEST = useSelector(questionsRequest);
  const QUESTIONS_ANSWERS = useSelector(questionsAnswers);
  const DATA_USER = useSelector(dataUser);
  const loginStatus = useSelector(login_status);

  useEffect(() => {
    props.disabledNextStep(true);
  }, []);

  // Helper function to check if user has active 30% ruling (considering new 2025 rules)
  const hasActive30Ruling = () => {
    const has30Ruling = DATA_USER.questionsResident.find((q: any) => q.question.id === 4 && [1].includes(q.answer.id));
    if (!has30Ruling) return false;
    // For year >= 2025, 30% ruling only counts if granted before Dec 2023
    if (DATA_USER.year >= 2025) {
      return DATA_USER.questionsResident.find((q: any) => q.question.id === 51 && [1].includes(q.answer.id));
    }
    return true;
  };

  // Helper function to check if user should be treated as no 30% ruling
  const treatedAsNo30Ruling = () => {
    const no30Ruling = DATA_USER.questionsResident.find((q: any) => q.question.id === 4 && [2, 3].includes(q.answer.id));
    if (no30Ruling) return true;
    // For year >= 2025, if 30% ruling was granted after Dec 2023, treat as no ruling
    if (DATA_USER.year >= 2025) {
      return DATA_USER.questionsResident.find((q: any) => q.question.id === 51 && [2].includes(q.answer.id));
    }
    return false;
  };

  useEffect(() => {
    const condition1 = DATA_USER.questionsResident.find((q: any) => q.question.id === 21);
    const condition2 = DATA_USER.questionsResident.find(
      (q: any) => q.question.id === 7 && [2].includes(q.answer.id)
    );
    const condition3 =
            (hasActive30Ruling() &&
                DATA_USER.questionsResident.find((q: any) => q.question.id === 15 && [2].includes(q.answer.id))) ||
            (hasActive30Ruling() &&
                DATA_USER.questionsResident.find((q: any) => q.question.id === 16));

    if (condition1 || condition2 || condition3) {
      props.disabledNextStep(false);
      if (loginStatus === 'success') {
        dispatch(setFinished(true));
      } else {
        dispatch(setFinished(false));
      }
    } else {
      dispatch(setFinished(false));
      props.disabledNextStep(true);
    }
  }, [DATA_USER.questionsResident]);

  // Scroll to active question
  useEffect(() => {
    const className = 'question-container';
    const elements = document.getElementsByClassName(className);
    if (elements) {
      elements[elements.length - 1].scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center',
      });
    }
  }, [DATA_USER.questionsResident]);

  return (
    <div className='container'>
      <div className='row d-flex justify-content-center align-items-start'>
        <div className='col-12 col-lg-8 p-lg-0'>
          {
            // 36 Do you own or rent your primary residency (house) in The Netherlands?
            <QuestionPrice
              question={QUESTIONS_REQUEST.find((q: any) => q.id === 9)}
              answers={QUESTIONS_ANSWERS.filter((a: any) => [6, 7, 8].includes(a.id))}
            />
          }
          {
            // 37 Purchased or sold this year?
            DATA_USER.questionsResident.find(
              (q: any) => q.question.id === 9 && [7].includes(q.answer.id)
            ) && (
              <QuestionPrice
                question={QUESTIONS_REQUEST.find((q: any) => q.id === 12)}
                answers={QUESTIONS_ANSWERS.filter((a: any) => [1, 2].includes(a.id))}
              />
            )
          }
          {
            // 38 Do you or your fiscal partners (if applicable) own investment real-estate located in The Netherlands?
            // For year >= 2025: 30% ruling only counts if granted before Dec 2023
            // prettier-ignore
            DATA_USER.questionsResident.find((q: any) => q.question.id === 8) &&
                        hasActive30Ruling() &&
                        DATA_USER.questionsResident.find((q: any) => q.question.id === 9)
                        && (
                          <QuestionPrice
                            question={QUESTIONS_REQUEST.find((q: any) => q.id === 13)}
                            answers={QUESTIONS_ANSWERS.filter((a: any) => [1, 2].includes(a.id))}
                          />
                        )
          }
          {
            // 39 How many addresses
            DATA_USER.questionsResident.find(
              (q: any) => q.question.id === 13 && [1].includes(q.answer.id)
            ) && (
              <QuestionPrice
                question={QUESTIONS_REQUEST.find((q: any) => q.id === 14)}
                answers={QUESTIONS_ANSWERS.filter((a: any) => [1, 2].includes(a.id))}
              />
            )
          }
          {
            // 40 Do you or your fiscal partner have a substantial shareholding ("?1") in a Dutch limited liability company
            // For year >= 2025: 30% ruling only counts if granted before Dec 2023
            // prettier-ignore
            (
              DATA_USER.questionsResident.find((q: any) => q.question.id === 14) ||
                            DATA_USER.questionsResident.find((q: any) => q.question.id === 13 && [2].includes(q.answer.id)) ||
                            DATA_USER.questionsResident.find((q: any) => q.question.id === 9 && [6, 8].includes(q.answer.id)) ||
                            (
                              DATA_USER.questionsResident.find((q: any) => q.question.id === 12) &&
                                DATA_USER.questionsResident.find((q: any) => q.question.id === 8 && [2].includes(q.answer.id))
                            ) ||
                            (
                              DATA_USER.questionsResident.find((q: any) => q.question.id === 12) &&
                                treatedAsNo30Ruling()
                            )
            ) && (
              <QuestionPrice
                question={QUESTIONS_REQUEST.find((q: any) => q.id === 15)}
                answers={QUESTIONS_ANSWERS.filter((a: any) => [1, 2].includes(a.id))}
              />
            )
          }
          {
            // 41 Did you receive income (“?”) from this?
            DATA_USER.questionsResident.find(
              (q: any) => q.question.id === 15 && [1].includes(q.answer.id)
            ) && (
              <QuestionPrice
                question={QUESTIONS_REQUEST.find((q: any) => q.id === 16)}
                answers={QUESTIONS_ANSWERS.filter((a: any) => [1, 2].includes(a.id))}
              />
            )
          }
          {
            // 42 Do you have a substantial shareholding* in a foreign limited liability company?
            // For year >= 2025: 30% ruling only counts if granted before Dec 2023
            // prettier-ignore
            treatedAsNo30Ruling() &&
                        DATA_USER.questionsResident.find((q: any) => q.question.id === 16 ||
                                DATA_USER.questionsResident.find((q: any) => q.question.id === 15 && [2].includes(q.answer.id))
                        ) && (
              <QuestionPrice
                question={QUESTIONS_REQUEST.find((q: any) => q.id === 7)}
                answers={QUESTIONS_ANSWERS.filter((a: any) => [1, 2].includes(a.id))}
              />
            )
          }
          {
            // 43 Did you receive income from this?
            DATA_USER.questionsResident.find(
              (q: any) => q.question.id === 7 && [1].includes(q.answer.id)
            ) && (
              <QuestionPrice
                question={QUESTIONS_REQUEST.find((q: any) => q.id === 21)}
                answers={QUESTIONS_ANSWERS.filter((a: any) => [1, 2].includes(a.id))}
              />
            )
          }
        </div>
        <CalculateCost />
        <div className='col-12 col-lg-3 p-lg-0 d-none d-lg-flex position-relative'></div>
      </div>
    </div>
  );
};

export default PriceQuestions;
